import soundcloudIcon from "../../assets/soundcloud.svg";
import { Box, Typography } from "@mui/material";
import { useInfo } from "../../hooks/useInfo";
import { useInView } from "react-intersection-observer";
import styles from "./styles";

const SoundCloudBanner = ({ playlistUrl: propUrl } = {}) => {
  const { data: info } = useInfo();
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.1 });

  const playlistUrl = propUrl ?? info?.soundcloudPlaylist;
  if (!playlistUrl) return null;

  const embedUrl = `https://w.soundcloud.com/player/?url=${encodeURIComponent(playlistUrl)}&color=%23ff5500&auto_play=false&hide_related=true&show_comments=false&show_user=false&show_reposts=false&show_teaser=false&sharing=false`;

  return (
    <Box
      ref={ref}
      sx={{
        ...styles.wrapperSx,
        opacity: inView ? 1 : 0,
        transform: inView ? "none" : "translateY(32px)",
      }}
    >
      <Box sx={styles.contentSx}>
        <Box sx={styles.badgeSx}>
          <Box component="img" src={soundcloudIcon} alt="" sx={styles.iconSx} />
          <Typography sx={styles.platformSx}>SoundCloud</Typography>
        </Box>

        <Box>
          <Typography sx={styles.titleSx}>
            Latest mixes<br />& releases.
          </Typography>
          <Typography sx={styles.descSx}>
            Follow us for new sets, live mixes and exclusive releases.
          </Typography>
        </Box>

        <Box
          component="a"
          href={info?.soundcloud || "#"}
          target="_blank"
          rel="noopener noreferrer"
          sx={styles.ctaSx}
        >
          <Typography className="cta-text" sx={styles.ctaTextSx}>Listen on SoundCloud</Typography>
          <Box className="cta-arrow" sx={styles.arrowSx}>↗</Box>
        </Box>
      </Box>

      <Box sx={styles.playerPanelSx}>
        <Box sx={styles.playerContainerSx}>
          <Box sx={styles.playerHeaderSx}>
            <Box sx={styles.windowControlsSx}>
              <Box sx={{ ...styles.dotSx, backgroundColor: "#ff5f57" }}>
                <Box component="span" className="dot-icon" sx={styles.dotIconSx}>×</Box>
              </Box>
              <Box sx={{ ...styles.dotSx, backgroundColor: "#ffbd2e" }}>
                <Box component="span" className="dot-icon" sx={styles.dotIconSx}>−</Box>
              </Box>
              <Box sx={{ ...styles.dotSx, backgroundColor: "#28c840" }}>
                <Box component="span" className="dot-icon" sx={styles.dotIconSx}>+</Box>
              </Box>
            </Box>
            <Box sx={styles.playerHeaderIconWrapSx}>
              <Box component="img" src={soundcloudIcon} alt="" sx={styles.playerHeaderIconSx} />
            </Box>
            <Typography sx={styles.playerHeaderTextSx}>Listen Now</Typography>
          </Box>

          <Box sx={styles.iframeWrapSx}>
            <iframe
              title="Booking Waves SoundCloud"
              width="100%"
              height="100%"
              allow="autoplay"
              src={embedUrl}
              style={{ display: "block", border: "none", width: "100%", height: "calc(100% + 56px)" }}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default SoundCloudBanner;
